import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase/firebaseConfig';
import { School } from '../types/school';

const SETTINGS_COLLECTION = 'settings';
const SCHOOLS_DOC = 'schools';

export class SchoolsService {
  static async getAllSchools(): Promise<School[]> {
    try {
      const docRef = doc(db, SETTINGS_COLLECTION, SCHOOLS_DOC);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        return [];
      }

      const schoolsMap = docSnap.data() || {};

      const schools: School[] = Object.values(schoolsMap).map((schoolData: any) => ({
        id: schoolData.id,
        name: schoolData.name,
        createdAt: schoolData.createdAt?.toDate() || new Date(),
      }));

      schools.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());

      return schools;
    } catch (error) {
      console.error('Error loading schools:', error);
      throw error;
    }
  }

  static async createSchool(school: School): Promise<void> {
    try {
      const docRef = doc(db, SETTINGS_COLLECTION, SCHOOLS_DOC);
      const docSnap = await getDoc(docRef);

      let schoolsMap: { [key: string]: any } = {};

      if (docSnap.exists()) {
        schoolsMap = docSnap.data() || {};
      }

      schoolsMap[school.id] = {
        id: school.id,
        name: school.name,
        createdAt: Timestamp.fromDate(school.createdAt),
      };

      await setDoc(docRef, schoolsMap);
    } catch (error) {
      console.error('Error creating school:', error);
      throw error;
    }
  }

  static async updateSchool(school: School): Promise<void> {
    try {
      const docRef = doc(db, SETTINGS_COLLECTION, SCHOOLS_DOC);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        throw new Error('Schools document not found');
      }

      const schoolsMap = docSnap.data() || {};

      if (!schoolsMap[school.id]) {
        throw new Error('School not found');
      }

      schoolsMap[school.id] = {
        ...schoolsMap[school.id],
        name: school.name,
      };

      await setDoc(docRef, schoolsMap);
    } catch (error) {
      console.error('Error updating school:', error);
      throw error;
    }
  }

}
